module.exports = __webpack_public_path__ + "static/media/surveillance.6d9150f1.svg";